import { fetchAPI } from "../config";

export async function getOrgByDomain(body) {
  const data = fetchAPI("/ssm_api_user/getorgbydomain", body);
  return data;
}
